import PropTypes from 'prop-types';
import React from 'react';
import ReactPlayer from 'react-player/lazy';

import { useObserver } from '../../tools/useObserver';
import * as styles from './ContentCard.module.css';
import ContentfulImage from './ContentfulImage';
import { ArrowLink } from './Links';
import PageSection from './PageSection';
import RichTextConverter from './RichText/RichTextConverter';

const ContentCard = ({
  heading,
  copy,
  image,
  wistiaUrl,
  imageBleed,
  imageSide,
  ctaLabel,
  ctaUrl,
  newWindow,
  limitImageHeight,
  backgroundStyle,
  useH2 = false,
  adjustForTallImage = false,
  ctaIsDownload = false,
  slim = false,
  moderate = false,
  curve = '',
  className = '',
  isSpark = false,
  animate = false,
  lazy = false,
}) => {
  // const isSvg = image?.file?.contentType === 'image/svg+xml';
  // let heightStyle = styles.free;
  // if (adjustForTallImage && !isSvg) {
  //   heightStyle = styles.heightAdjust;
  // } else if (adjustForTallImage && isSvg) {
  //   heightStyle = styles.svgLimitHeight;
  // } else if (isSvg) {
  //   heightStyle = styles.svgHeight;
  // }
  const [containerRef, isVisible] = useObserver({ threshold: 0.25 });

  const imageDirection = imageSide === 'Left' ? 'Left' : 'Right';

  const imgStyle = { objectFit: 'contain', maxHeight: '750px' };
  if (limitImageHeight) {
    imgStyle.maxHeight = '300px';
  }
  let mainMedia;
  if (image) {
    //mainMedia = <img className={styles.heightAdjust} src={get(image, 'file.url')} alt={get(image, 'title')} />;
    mainMedia = (
      <ContentfulImage
        lazy={lazy}
        imageFragment={image}
        className={[styles.svg, isSpark ? styles.sparkImg : ''].join(' ')}
      />
    );
  }
  if (wistiaUrl) {
    mainMedia = (
      <div className={`player-wrapper-${wistiaUrl}`}>
        <ReactPlayer
          className={`react-player-${wistiaUrl}`}
          controls={false}
          width={'100%'}
          height="100%"
          url={wistiaUrl}
        />
      </div>
    );
  }

  const isCopyRaw = typeof copy !== 'string';
  return (
    <PageSection
      wide={imageBleed}
      className={[backgroundStyle, className].join(' ')}
      curveTop={curve === 'Top'}
      curveBottom={curve === 'Bottom'}
      slim={slim}
      moderate={moderate}
    >
      <div className={[styles.grid, imageBleed ? styles.wide : ''].join(' ')} ref={containerRef}>
        <div
          className={[
            styles['image' + imageSide],
            limitImageHeight ? styles.minWidth : '',
            adjustForTallImage ? styles.imageAdjust : '',
            isSpark ? styles.sparkImgWrap : '',
            animate ? styles['slide' + imageDirection] : '',
            isVisible && animate ? styles.visible : '',
          ].join(' ')}
        >
          {mainMedia}
        </div>
        <div
          className={[
            styles['copy' + imageSide],
            imageBleed ? styles.padAdjust : '',
            animate ? styles.hidden : '',
            isVisible && animate ? styles.fadeUp : '',
          ].join(' ')}
        >
          {heading && !useH2 && <h3>{heading}</h3>}
          {heading && useH2 && <h2>{heading}</h2>}
          {isCopyRaw && <RichTextConverter copy={copy} />}
          {!isCopyRaw && <p>{copy}</p>}
          {ctaLabel && <ArrowLink label={ctaLabel} url={ctaUrl} isExternal={newWindow} isDownload={ctaIsDownload} />}
        </div>
      </div>
    </PageSection>
  );
};

ContentCard.propTypes = {
  heading: PropTypes.string,
  copy: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  image: PropTypes.object,
  imageBleed: PropTypes.bool,
  imageSide: PropTypes.oneOf(['Left', 'Right']),
  ctaLabel: PropTypes.string,
  ctaUrl: PropTypes.string,
  curve: PropTypes.oneOf(['Top', 'Bottom', 'No']),
  slim: PropTypes.bool,
};

export default ContentCard;
